module.exports = __webpack_public_path__ + "static/xmasbibs-78388170900d72f0a79767b453001781.jpeg";